<template>
  <div class="other-area">
    <div class="margin-left-2td3">
      部门标识
    </div>
    <div class="door"></div>
    <!-- <div class="abclogo">ABC区 <i class="el-icon-top"></i></div>
    <div class="horizontalLine1"></div>
    <div class="horizontalLine2"></div> -->
  </div>
</template>

<script>
import '../common.scss'

export default {
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
  .other-area{
    flex: 1;
    border:1px solid #d9d9d9;
    position: relative;
  }
  .door{
    position: absolute;
    top:28rem;
    width: 2rem;
    height: 10rem;
    background-color: #daeef3;
  }
  .abclogo{
    position: absolute;
    left:10rem;
    top:51rem;
    width: 8rem;
    height: 8rem;
    background-color: #4f81bd;
    text-align: center;
    color: #fff;
    line-height: 8rem;
  }
  .horizontalLine1{
    position: absolute;
    left:10rem;
    top:78rem;
    width: 8rem;
    height: 1rem;
    background-color: #a6a6a6;
  }
  .horizontalLine2{
    position: absolute;
    left:10rem;
    top:80rem;
    width: 8rem;
    height: 0.5rem;
    background-color: #ffff00;
  }
</style>
